<template>
  <LoadingIcon v-if="isLoading" />
  <Card
    v-else
    :class="$style.card"
    data-test-id="GroupMembership__widgetCard"
  >
    <HeadingExtraSmall
      hasMargin
      text="Group Membership Updates"
      weight="bold"
    >
      {{ manualGroupMembership }}
    </HeadingExtraSmall>
    <ul
      :class="$style.columnHeader"
    >
      <li>
        <HeadingExtraSmall
          weight="bold"
        >
          Groups
        </HeadingExtraSmall>
      </li>
      <li :class="$style.manualChanges">
        <HeadingExtraSmall
          weight="bold"
        >
          Manual Changes
        </HeadingExtraSmall>
      </li>

      <li
        :class="$style.autoMatic"
      >
        <HeadingExtraSmall
          weight="bold"
        >
          Automatic Changes
          <div
            :class="$style.subHeader"
          >
            (Coming Soon)
          </div>
        </HeadingExtraSmall>
      </li>
    </ul>
    <GroupList
      :list="groupData"
      @handleClickAction="navigateToInvestigativePage"
    />
  </Card>
</template>
<script>
import {
  Card,
  HeadingExtraSmall,
  LoadingIcon,
} from '@jumpcloud/ui-components';
import {
  ItemTypeConsts,
  ItemTypeRoutes,
  StoreModuleMap,
} from 'client/util/Constants';
import { UiEvents } from '@jumpcloud/ui-events-vue';
import {
  eventLocations,
} from 'client/GrowthEngineering/utilities/GrowthConstants';
import { mapActions, mapGetters } from 'vuex';
import GroupList from 'client/HomePageV2/components/GroupList';
import HomeWidgetConsts from 'client/HomePageV2/constants/HomeWidgetConsts';
import Util from 'client/util/Util';

const insightsEventModule = StoreModuleMap[ItemTypeConsts.insightsEvent];
const GroupCollection = StoreModuleMap[ItemTypeConsts.group];
const { manualGroupMembership } = HomeWidgetConsts.widgetNames;
const {
  homePage,
} = eventLocations;

export default {
  name: 'GroupMembershipWidget',
  components: {
    Card,
    HeadingExtraSmall,
    GroupList,
    LoadingIcon,
  },

  viewAllRoute: ItemTypeRoutes[ItemTypeConsts.viewManualGroupMembership],

  data: () => ({
    manualGroupMembership,
    groupData: [],
    isLoading: true,
  }),

  computed: {
    startTime() {
      const ts = new Date();
      ts.setDate(ts.getDate() - 1);
      return ts.toISOString();
    },

    ...mapGetters(GroupCollection, {
      items: 'getCollection',
    }),
  },

  created() {
    this.handleCreated();
  },

  methods: {
    ...mapActions(insightsEventModule, [
      'fetchWidgetData',
    ]),

    ...mapActions(GroupCollection, [
      'fetchEntireCollection',
    ]),

    getFilters(filter) {
      const ids = [];
      filter.forEach((item) => {
        if (item.type === 'user_group') {
          ids.push(item.id);
        }
      });
      return ids;
    },

    async handleCreated() {
      await this.fetchEntireCollection();
      const ids = this.getFilters(this.items);
      const field = {
        service: [
          'directory',
        ],
        start_time: this.startTime,
        fields: [
          'association.connection.from.object_id',
          'association.connection.to.object_id',
        ],
        search_term: {
          and: [
            {
              'association.connection.from.type': 'user_group',
            },
            {
              'association.connection.to.type': 'user',
            },
            {
              'association.connection.from.object_id': ids,
            },
          ],
        },
        limit: 4,
        from: 0,
        sort_by: 'count',
        include_agg_fields: [
          'association.connection.from.name',
        ],
        sort: 'DESC',
      };

      return this.fetchWidgetData({ field }).then(res => {
        const { buckets } = res.results;
        buckets.forEach(element => {
          const obj = {};
          obj.name = element.data.association.connection.from.name;
          obj.href = `${this.$options.viewAllRoute}/${element.key}`;
          obj.value = element.total_count;
          this.groupData.push(obj);
        });
      })
        .catch(() => {
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    navigateToInvestigativePage(item) {
      UiEvents.triggerLinkClicked({
        description: 'Group Membership Updates - Home Page',
        page: homePage,
        section: 'Home Widgets',
        toUrl: 'viewAll',
        text: 'Group Membership Updates Widget',
      });
      Util.redirect(item.href);
    },

  },
};
</script>
<style module scoped>
@value (cardShadow1) from '~css/shadows.css';

.autoMatic {
  margin-left: 2rem;
}

.card {
  box-shadow: cardShadow1;
}

.columnHeader {
  display: flex;
  list-style: none;
  padding: 0.3rem;
}

.manualChanges {
  margin-left: 8rem;
}

.subHeader {
  font-style: italic;
  font-weight: 400;
  padding-left: 1.5rem;
}

</style>
